export const LOAD_DATA_LOCKS = `LOAD_DATA_LOCKS`;
export const LOAD_DATA_LOCKS_START = `${LOAD_DATA_LOCKS}_START`;
export const LOAD_DATA_LOCKS_SUCCESS = `${LOAD_DATA_LOCKS}_SUCCESS`;
export const LOAD_DATA_LOCKS_FAIL = `${LOAD_DATA_LOCKS}_FAIL`;

export const UPDATE_DATA_LOCKS = 'UPDATE_DATA_LOCKS';
export const UPDATE_DATA_LOCKS_START = `${UPDATE_DATA_LOCKS}_START`;
export const UPDATE_DATA_LOCKS_SUCCESS = `${UPDATE_DATA_LOCKS}_SUCCESS`;
export const UPDATE_DATA_LOCKS_FAIL = `${UPDATE_DATA_LOCKS}_FAIL`;

export const CLEAR_UPDATED_DATA_LOCK = 'CLEAR_UPDATED_DATA_LOCK';

export const getDataLocks = () => ({
  type: LOAD_DATA_LOCKS,
  meta: {
    xmApi: true,
    uri: '/webapi/xm/1/settings',
    method: 'get',
    params: {
      embed: 'dataLocks',
    },
  },
});

export const setDataLocks = (params = {}, modifiedObjectType) => {
  const { objectType, property, locked } = params;
  const newParams = {
    dataLocks: {
      [objectType]: {
        [property]: locked,
      },
    },
  };

  return {
    type: UPDATE_DATA_LOCKS,
    modifiedObjectType,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/settings`,
      method: 'post',
      params: newParams,
    },
  };
};

export const clearUpdatedDataLock = () => ({
  type: CLEAR_UPDATED_DATA_LOCK,
});
